<template>
  <div class="w-100">
      <Loader class="w-100" :loading="loading">
          <div class=" p-list-representation-wrapper align-items-start">
              <div  class="w-100p-list-representation-content row mr-auto ml-auto align-items-start">
                <div class="w-100" >
                  <appHeader></appHeader>
                </div>

                <div class=" row p-list-representation-data w-100">
                  <contentList
                  @selectedCity="selectedCity"
                  @selectedProvince="selectedProvince"
                  @searchData="searchData"

                  :page="page"
                  :update-city-selected="updateCitySelected"
                  :city-selected     = "citySelected"
                  :province-selected = "provinceSelected"
                  :citys="citys"
                  :province-items="provinceItems"
                  :form-data="formData"
                  :status-player="statusPlayer"
                  ></contentList>
                </div>

              </div>

          </div>

        <tableContent :page="page" @rejectionTableItem="rejectionTableItem" @acceptTableItem="acceptTableItem" :table-data="tableData" @paganationChangePage="paganationChangePage"  ></tableContent>
      </Loader>
  </div>
</template>

<script>
import contentList from '../components/playerDescription/contentList';
import appHeader from '../components/includes/AppHeader';
import tableContent from '../components/playerDescription/tableContent';
import addCama from '../modules/addCama.js'
import settings from '../modules/settings';



export default {
  name: "descriptionDayReservation",
  components: {
    contentList,
    appHeader,
    tableContent,
  },

  props: {

  },

  data() {
    return {
      loading                                 : true,
      citys                                   : [

      ],
      provinceItems                           : [

      ],
      updateDataRepresentation                : {},
      citySelected                            : {
        id   : -1,
        name  : 'انتخاب کنید',
      },
      provinceSelected                        : {
        id   : -1,
        name  : 'انتخاب کنید',
      },
      updateCitySelected                      : 0,
      page                                    : 0,
      checkEmptyCity                     : 'default',
      formData      : {
        name             : '',
        mobile           : '',
        from_date        : '',
        to_date          : '',
        content_approval : '',
        include_sans     : 1,
        include_hall     : 1,
        is_dongi         : 0,
        page             : 1,
      },
      tableData                               : [],
      page                                    : 1,
      checkRunFirstGetDefaultProvinceAndCity  : 'initialLoaded',
      statusRunPaganation                     : true,
      resetPagePaganation                     : 0,
      statusPlayer                            : [
        {
          id    : `approved`,
          title : 'تایید',
        },
        {
          id    : `declined`,
          title : 'رد',
        },
      ],
      updateCitySelected                      : 0,


    }
  },

  watch: {

  },

  created() {
  },


  mounted() {
    if (this.$route.name == 'playerDescription') {
      this.formData.is_dongi = 0;
    }
    else {
      this.formData.is_dongi = 1;
    }

    this.getProvinceAndCity();
  },


  methods: {
    updateTableDataAndProvinceAndCity(page){
      this.loading                                 = true;
      this.formData.page                           = page;
      this.checkRunFirstGetDefaultProvinceAndCity  = 'preventGetProvinceAndCity';
      this.getTableData();
    },

    paganationChangePage(page){


      if (!this.checkPermissionMultiUpdateTableData) {
        // در صورتی که کاربر در صفحه دو تیبل باشد  و عدد صفحه تیبل تغییر کند //
        // دو در خواست اجرا می شود برای جلوگیری از دو در خواست همزمان //
        // کد زیر نوشته شد //
        if (page != 1) {
          this.checkPermissionMultiUpdateTableData = true;
        }
      }


      if (this.checkPermissionMultiUpdateTableData) {
        if (this.citySelected.id == -1) {
          this.formData.city_id = '';
        }

        this.page = page;
        this.updateTableDataAndProvinceAndCity(page);
      }
      else {
        // اجازه اجرا شدن لاجیک کال بک پجینیشن //
        this.checkPermissionMultiUpdateTableData = true;
      }

    },

    searchData(data){
      // citySelected has nothing item select  //
      if (this.citySelected.id == -1) {
        this.formData.city_id = '';
      }

      for (let key in data) {
        this.formData[key] = data[key];
      }

      this.page           = 1;
      this.checkPermissionMultiUpdateTableData     = false;

      this.updateTableDataAndProvinceAndCity(this.page);
    },


    selectedCity(data){

      if (data.id != -1) {
        this.citySelected   = data
        this.formData.city_id = data.id;
      }


    },

    selectedProvince(data){

      if (this.checkEmptyCity != 'firstCheckSelectedCity') {
        this.citySelected  = {name:'انتخاب کنید',id:-1};
      }

      if (data.id != -1) {
        this.provinceSelected = data;
        this.formData.province_id =  data.id;
        this.updateCitySelected++;
        this.citys               = data.city;
        this.checkEmptyCity = 'eventUpdate';
      }


    },

    getDefaultProvinceAndCity(dataProvinceAndCity){
      let getProvince           = [];
      let getCity               = [];
      const cityIdDefault       =  this.formData.city_id;
      const provinceIdDefault   =  this.formData.province_id;

      dataProvinceAndCity.data.map((t)=>{
          getProvince = [...getProvince,t];

          if (provinceIdDefault == t.id ) {
            this.provinceSelected  = t;
          }

          t.city.map((contentCity)=>{
            if (cityIdDefault == contentCity.id ) {
              this.citySelected  = contentCity;
            }
            getCity               = [...getCity,contentCity];
          })
      })

      this.citys               = getCity;
      this.provinceItems       = getProvince;
      this.checkEmptyCity = 'firstCheckSelectedCity';
    },

    findProvinceAndCityTable(tableData){
          tableData.map((contentTable)=>{
            // add cama in amount value //
            const resultAddCama                 = addCama(contentTable.real_price);
            contentTable.addCamaPrice           = resultAddCama

              this.provinceItems.map((t)=>{
                if (t.id == contentTable.province_id) {
                    contentTable.findProvinceOfAllProvinces = t;
                    t.city.map((contentCity)=>{
                        if (contentCity.id == contentTable.city_id) {
                            contentTable.findCityOfAllCitys = contentCity;
                        }
                    })
                }
              })
        })
    },

    getTableData(){

      this.$store
      .dispatch('playerDescription/getTableData', {
        data : {
          ...this.formData,
        }
      })
      .then((res)=>{
        this.loading                               = false;
        this.convertTimeStampInToJalali(res.tableData.data);
        this.findProvinceAndCityTable(res.tableData.data);
        this.tableData    = res.tableData.data;
      })
    },

    getProvinceAndCity(){
      this.$store
      .dispatch('playerDescription/getProvinceAndCity', {
        data : {
          ...this.formData,
        }
      })
      .then((res)=>{
          this.getDefaultProvinceAndCity(res);
          this.getTableData();
      })
    },

    convertTimeStampInToJalali(tableData){
      tableData.map((t,i)=>{
        const resultConvert    = this.$moment.unix(t.created_at).format("jYYYY/jMM/jDD HH:mm:ss").split(' ');
        t.dateConvertedJali    =  resultConvert[0];
        t.timeConvertedJali    =  resultConvert[1];
      })
    },

    rejectionTableItem(data){
      data.beforChangeApproval  = data.content_approval;
      data.content_approval     = 'declined';
      this.acceptRejectionDataTatble(data);
    },

    acceptTableItem(data){
      data.beforChangeApproval  = data.content_approval;
      data.content_approval     = 'approved';
      this.acceptRejectionDataTatble(data);
    },

    acceptRejectionDataTatble(data){
      this.loading         = true;

      this.$store
      .dispatch('playerDescription/acceptPlayer', {
        data : {
          ...data,
        }
      })
      .then((res)=>{
        if (res.is_successful) {
          this.getTableData();
        }
        else {
          data.content_approval = data.beforChangeApproval;
          this.loading = false;
        }
      })
    },





  }


}
</script>
